import { Skeleton } from '@skin-seoul/design-system';
import React from 'react';

interface HorizontalProductCardSkeletonProps {
  className?: string;
}

export const HorizontalProductCardSkeleton = ({ className }: HorizontalProductCardSkeletonProps) => {
  return (
    <div className={`flex w-full h-[147px] relative ${className || ''}`}>
      <div className="flex flex-row rounded-[8px] overflow-hidden h-full w-full items-center bg-generic-0">
        <Skeleton className="w-[130px] h-full rounded-[8px 0 0 8px]" />
        <div className="flex flex-row flex-1 h-full justify-between px-3">
          <div className="flex flex-col gap-3 flex-1 h-full justify-center">
            <div className="flex flex-col gap-2">
              <Skeleton className="w-[120px] h-[14px] rounded-[4px]" />
              <Skeleton className="w-full h-[14px] rounded-[4px]" />
              <Skeleton className="w-[80%] h-[14px] rounded-[4px]" />
              <Skeleton className="w-[80px] h-[16px] rounded-[4px]" />
            </div>
            <Skeleton className="w-[90%] h-[20px] rounded-[4px]" />
          </div>
        </div>
      </div>
    </div>
  );
};
